import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Spedizione} from '../../../_models/Spedizione';
import {MessageConfirm} from '../../../_helpers/message-confirm.service';
import {SpedizioniService} from '../../../_services/spedizioni.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SaveMessage} from '../../../_helpers/save-message';

@Component({
  selector: 'app-documento-magazzino-item',
  templateUrl: './documento-magazzino-item.component.html',
  styleUrls: ['./documento-magazzino-item.component.scss'],
  standalone: false
})
export class DocumentoMagazzinoItemComponent {
  @Input() spedizione: Spedizione;
  @Output() spedizioneSended = new EventEmitter<Spedizione>();

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private spedizioniService: SpedizioniService,
    private saveMessage: SaveMessage,
    private deleteConfirm: MessageConfirm) { }


  deleteSpedizione(id: number): void {
    this.deleteConfirm
      .presentAlert(`Sei sicuro di voler eliminare la spedizione ${id} e relativi riferimenti?`, () => {
        this.spedizioniService.deleteSpedizione(this.organizzazioniService.organizzazioneId, id)
          .then(() => {
            this.saveMessage.messageInfo('Spedizione eliminata con successo.');
          })
          .catch(() => this.saveMessage.messageError("Ci sono problemi con l'eliminazione della spedizione."));
      });
  }

  selectSpedizione = (spedizione: Spedizione) => this.spedizioneSended.emit(spedizione);
}
